<template>
  <div>
    <div class="photo">
        <a>
            <img :src="require('@/assets/img/photo.png')" alt="photo"/>
        </a>
    </div>
  </div>
</template>

<script>
export default {
    name: 'Photo',
}
</script>

<style scoped lang="scss">
    .photo {
        a:focus {
            outline: none;
        }
        img {
            width: 200px;
            height: 200px;
            border-radius: 50%;
            display: inline-block;
            box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.4);
        }
        
    }
    img {
        max-width: 100%;
    }
</style>